module.exports = __webpack_public_path__ + "static/media/close.f98a96d2.svg";